/**
 * Returns a function which can take any number of new Promises and resolves with the return value of the most recently provided promise.
 */
export function takeLast<T>(): (p: Promise<T>) => Promise<T> {
    let activePromise: Promise<T> | undefined = undefined;
    let activeResolve: ((value: T | PromiseLike<T>) => void) | undefined = undefined;
    let activeReject: ((reason?: unknown) => void) | undefined = undefined;
    let counter = 0;

    const reset = (): void => {
        activePromise = undefined;
        activeReject = undefined;
        activeResolve = undefined;
    };

    return (providedPromise: Promise<T>) => {
        counter++;
        const localCounter = counter;
        if (!activePromise) {
            activePromise = new Promise((resolve, reject) => {
                activeResolve = resolve;
                activeReject = reject;
            });
        }
        providedPromise.then((val) => {
            if (counter === localCounter) {
                activeResolve?.(val);
                reset();
            }
        });
        providedPromise.catch((e) => {
            if (counter === localCounter) {
                activeReject?.(e);
                reset();
            }
        });

        return activePromise;
    };
}
